<template>
	<v-card outlined class="pa-2 mt-3" elevation="3">
		<div v-if="$route.matched.some(matched => matched.name === 'management') && persons.length">
			<div class="text-right">
				<span v-for="(person, i) in persons" :key="i">
					<v-tooltip left v-if="i < 11">
						<template v-slot:activator="{ on, attrs }">
							<span
								v-on="on"
								v-bind="attrs"
								class="ma-1"
								@click="goToMarker(person._id)"
							>
								<avatar
									:headline="false"
									:size="$vuetify.breakpoint.lgAndUp ? '20' : '10'"
									icon
									:name="person.firstName"
									:last-name="person.lastName"
									:url="person.avatar"
								/>
							</span>
						</template>
						<span>
							{{ person.firstName }}
							{{ person.lastName ? person.lastName : '' }}
						</span>
					</v-tooltip>
				</span>
				<v-menu v-model="menu" :close-on-content-click="false" :nudge-width="100" offset-x>
					<template v-slot:activator="{ on, attrs }" v-if="persons.length > 10">
						<v-btn color="primary" x-small text v-bind="attrs" v-on="on">
							...ver todos
						</v-btn>
					</template>
					<v-card max-height="200">
						<v-list>
							<v-list-item
								v-for="person in persons"
								:key="person._id"
								@click="goToMarker(person._id)"
							>
								<v-list-item-avatar>
									<avatar
										:headline="false"
										size="10"
										icon
										:name="person.firstName"
										:last-name="person.lastName"
										:url="person.avatar"
									/>
								</v-list-item-avatar>

								<v-list-item-content>
									<v-list-item-title
										>{{ person.firstName }}
										{{
											person.lastName ? person.lastName : ''
										}}</v-list-item-title
									>
								</v-list-item-content>
							</v-list-item>
						</v-list>
					</v-card>
				</v-menu>
			</div>
		</div>
		<v-sheet>
			<v-text-field
				id="pac-input"
				class="mx-2 pt-2"
				type="text"
				placeholder="Acerque el mapa a una ubicación conocida."
				outlined
				dense
				filled
				v-show="!$route.matched.some(matched => matched.name === 'management')"
			>
			</v-text-field>
		</v-sheet>
		<div style="position: relative;">
			<template v-if="!$route.matched.some(matched => matched.name === 'management')">
				<div
					v-if="polygons.length"
					class="ma-2"
					style="position: absolute; top: 0; right: 0; z-index: 1;"
				>
					<v-btn fab color="white" class="ma-1" small @click="savePolygon">
						<v-icon color="success">mdi-content-save</v-icon>
					</v-btn>
					<v-btn fab color="white" class="ma-1" small @click="undoPolygon">
						<v-icon color="error">mdi-delete</v-icon>
					</v-btn>
				</div>
			</template>

			<div :id="idMap" class="divMap" :style="{ height: heightMap }"></div>
		</div>
		<span v-if="!polygons.length" class="caption" color="warning">
			Aun no ha ingresado la ubicacion de este establecimiento.
		</span>
		<v-overlay :value="overlay">
			<v-progress-circular indeterminate size="48"></v-progress-circular>
		</v-overlay>
	</v-card>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import icon from '@/assets/icon.png';
import moment from 'moment';

export default {
	name: 'Geofence',
	components: {
		Avatar: () => import('@/components/ui/Avatar'),
	},
	props: {
		toggleConfigMarksPerDay: {
			type: Boolean,
			default: false,
		},
		idMap: {
			type: String,
			required: true,
		},
		idPlace: {
			type: String,
			required: true,
		},
		place: {
			type: Object,
			required: true,
		},
		heightMap: {
			type: String,
			default: '400px',
		},
		setAddress: {
			type: Function,
		},
	},
	data() {
		return {
			infowindow: null,
			menu: false,
			persons: [],
			markers: [],
			overlay: false,
			map: null,
			allEvents: [],
			polygons: [],
			poly: null,
			centerPoligon: null,
			formattedAddress: '',
			defaultCenter: { lat: -33.4533107, lng: -70.6633059 },
		};
	},
	computed: {
		...mapGetters({
			updateMap: 'Lodging/updateMap',
			selectedPlace: 'Lodging/selectedPlace',
		}),
	},
	watch: {
		selectedPlace() {
			this.initMap().then(() => this.getPersons());
		},
		toggleConfigMarksPerDay() {
			for (let i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap(null);
			}
			this.markers = [];
			this.getPersons();
			this.setUpdateMap();
		},
		polygons(newValue) {
			if (newValue.length) {
				// eslint-disable-next-line no-undef
				this.poly = new google.maps.Polygon({
					paths: this.polygons,
					strokeColor: '#FF0000',
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: '#FF0000',
					fillOpacity: 0.35,
				});
				this.poly.setMap(this.map);
				// eslint-disable-next-line no-undef
				const bounds = new google.maps.LatLngBounds();
				for (const poly of this.polygons) {
					// eslint-disable-next-line no-undef
					bounds.extend(new google.maps.LatLng(poly.lat, poly.lng));
				}

				// eslint-disable-next-line no-undef
				this.centerPoligon = new google.maps.Marker({
					position: {
						lat: bounds.getCenter().lat(),
						lng: bounds.getCenter().lng(),
					},
					title: this.place.name,
					icon,
					// eslint-disable-next-line no-undef
					animation: google.maps.Animation.DROP,
				});
				this.centerPoligon.setMap(this.map);
				// eslint-disable-next-line no-undef
				this.map.setCenter({
					lat: bounds.getCenter().lat(),
					lng: bounds.getCenter().lng(),
				});
				this.map.setZoom(18);
				this.info(this.centerPoligon, this.place.name ? this.place.name : this.place.text);
			} else {
				this.map.setCenter(this.defaultCenter);
				this.map.setZoom(8);
			}
		},
		updateMap(newVal) {
			if (newVal) {
				for (let i = 0; i < this.markers.length; i++) {
					this.markers[i].setMap(null);
				}
				this.markers = [];
				this.getPersons();
			}
		},
	},
	mounted() {
		this.initMap().then(() => this.getPersons());
	},
	methods: {
		async initMap() {
			// eslint-disable-next-line no-undef
			this.map = new google.maps.Map(document.getElementById(this.idMap), {
				zoom: 8,
				center: this.defaultCenter,
				streetViewControl: false,
				scaleControl: true,
				fullscreenControl: false,
				scrollwheel: true,
			});

			// eslint-disable-next-line no-undef
			const geocoder = new google.maps.Geocoder();

			if (this.place.geofence) this.polygons = this.place.geofence;

			// eslint-disable-next-line no-undef
			this.drawingManager = new google.maps.drawing.DrawingManager({
				drawingControl: this.$route.name == 'places',
				drawingControlOptions: {
					// eslint-disable-next-line no-undef
					position: google.maps.ControlPosition.TOP_CENTER,
					drawingModes: ['polygon'],
				},
				polygonOptions: {
					editable: true,
					strokeWeight: 2,
					clickable: false,
					zIndex: 1,
					strokeColor: '#FF0000',
					fillColor: '#FF0000',
					fillOpacity: 0.35,
					draggable: true,
				},
			});
			this.drawingManager.setMap(this.map);
			// eslint-disable-next-line no-undef
			google.maps.event.addListener(this.drawingManager, 'overlaycomplete', event => {
				let path = event.overlay;
				if (this.poly) this.poly.setMap(null);
				if (this.centerPoligon) this.centerPoligon.setMap(null);
				if (event.type === 'polygon') {
					path.setMap(null);
					this.drawingManager.setDrawingMode(null);
					let temp = [];
					for (var i = 0; i < path.getPath().getLength(); i++) {
						temp.push({
							lat: path
								.getPath()
								.getAt(i)
								.lat(),
							lng: path
								.getPath()
								.getAt(i)
								.lng(),
						});
					}
					geocoder.geocode({ location: temp[0] }, (results, status) => {
						if (status === 'OK') {
							if (results[0]) {
								this.formattedAddress = results[0].formatted_address;
								this.setAddress(this.formattedAddress);
							}
						}
					});

					this.polygons = temp;
				} else if (event.type === 'marker') {
					const position = path.position;
					// eslint-disable-next-line no-undef
					const isInside = google.maps.geometry.poly.containsLocation(
						position,
						this.poly
					);
					isInside ? console.info('d') : console.log('f');
				}
			});

			// Create the search box and link it to the UI element.
			const input = document.getElementById('pac-input');

			// eslint-disable-next-line no-undef
			const searchBox = new google.maps.places.SearchBox(input);

			this.map.addListener('bounds_changed', () => {
				searchBox.setBounds(this.map.getBounds());
			});

			// Listen for the event fired when the user selects a prediction and retrieve
			// more details for that place.
			searchBox.addListener('places_changed', () => {
				const places = searchBox.getPlaces();

				if (places.length == 0) {
					return;
				}

				// For each place, get the icon, name and location.
				// eslint-disable-next-line no-undef
				const bounds = new google.maps.LatLngBounds();
				places.forEach(place => {
					if (!place.geometry) {
						console.log('Returned place contains no geometry');
						return;
					}

					if (place.geometry.viewport) {
						// Only geocodes have viewport.
						bounds.union(place.geometry.viewport);
					} else {
						bounds.extend(place.geometry.location);
					}
				});
				this.map.fitBounds(bounds);
			});
		},
		async getPersons() {
			const persons = await this.getPersonsInPlace({
				placeId: this.idPlace,
				toggleConfigMarksPerDay: this.toggleConfigMarksPerDay,
			});
			if (persons) {
				this.persons = persons.filter(person => person.geolocation);
				this.setPersonMarker(persons);
			}
		},
		undoPolygon() {
			this.overlay = true;
			const data = { geofence: null, address: '' };
			this.setAddress('');
			if (this.place.geofence) {
				this.pathGeofence({ payload: data, id: this.idPlace })
					.then(() => {
						this.polygons = [];
						this.poly.setMap(null);
						this.centerPoligon.setMap(null);
						this.overlay = false;
						this.snackbar({
							content: `Ubicación de ${
								this.place.name ? this.place.name : this.place.text
							} ha sido removida con exito`,
							color: 'success',
						});
					})
					.catch(error =>
						this.snackbar({
							content: error.message,
							color: 'error',
						})
					);
			} else {
				this.polygons = [];
				this.poly.setMap(null);
				this.centerPoligon.setMap(null);
				this.overlay = false;
			}
		},
		savePolygon() {
			this.overlay = true;
			const data = { geofence: this.polygons, address: this.formattedAddress };
			this.pathGeofence({ payload: data, id: this.idPlace })
				.then(() => {
					this.overlay = false;
					this.snackbar({
						content: `Ubicación de ${
							this.place.name ? this.place.name : this.place.text
						} guardada con exito`,
						color: 'success',
					});
				})
				.catch(error =>
					this.snackbar({
						content: error.message,
						color: 'error',
					})
				);
		},
		info(marker, title, subtitle) {
			const contentString = this.getConterStringInfo(title, subtitle);
			// eslint-disable-next-line no-undef
			const infowindow = new google.maps.InfoWindow({
				content: contentString,
			});
			marker.addListener('click', () => {
				infowindow.open(this.map, marker);
			});
		},
		setPersonMarker(persons) {
			if (!persons) return;
			for (const person of persons) {
				if (person.geolocation) {
					this.markers.push(
						// eslint-disable-next-line no-undef
						new google.maps.Marker({
							position: {
								lat: person.geolocation.coordinates[0],
								lng: person.geolocation.coordinates[1],
							},
							map: this.map,
							person: person,
							label: person.firstName.substring(0, 1),
						})
					);
				}
			}
			if (this.polygons.length && this.markers.length)
				this.markers.forEach(marker => {
					marker.setMap(this.map);
					this.info(marker, this.getTitleInfo(marker), this.getSubTitleInfo(marker));
				});
		},
		goToMarker(id) {
			this.menu = false;
			if (this.infowindow) this.infowindow.close();
			const marker = this.markers.find(marker => marker.person._id === id);
			let title = this.getTitleInfo(marker);
			let subtitle = this.getSubTitleInfo(marker);
			const contentString = this.getConterStringInfo(title, subtitle);
			// eslint-disable-next-line no-undef
			this.infowindow = new google.maps.InfoWindow({
				content: contentString,
			});

			this.infowindow.open(this.map, marker);
		},
		getTitleInfo(marker) {
			return `${marker.person.firstName} ${
				marker.person.lastName ? marker.person.lastName : ''
			}`;
		},
		getSubTitleInfo(marker) {
			if (marker.person.geolocation)
				return `Ultima actualización: ${moment(marker.person.geolocation.date).format(
					'LLLL'
				)}`;
		},
		getConterStringInfo(title, subtitle) {
			return `<div style="color: black;" class="title text-capitalize">
			${title}</br><span class="subtitle-2">${subtitle ? subtitle : ''}</span></div>`;
		},
		...mapActions({
			setGeolocation: 'Person/setGeolocation',
			pathGeofence: 'Place/pathGeofence',
			getPersonsInPlace: 'Person/getPersonsInPlace',
			updateNotification: 'Lodging/updateNotification',
		}),
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
			setUpdateMap: 'Lodging/setUpdateMap',
		}),
	},
};
</script>

<style scoped>
.divMap {
	background-color: white;
	width: 100%;
	margin-top: 10px;
}

#pac-input {
	background-color: #fff;
	font-family: Roboto;
	font-size: 15px;
	font-weight: 300;
	margin-left: 0px;
	padding: 0 11px 0 13px;
}

#pac-input:focus {
	border-color: #4d90fe;
}
</style>
